module.exports = __webpack_public_path__ + "static/img/shanx_light.b4bbc7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/shanx_light.png
// module id = mneB
// module chunks = 1